import { render, staticRenderFns } from "./ListBuyerClaim.vue?vue&type=template&id=27a0abc7&scoped=true"
import script from "./ListBuyerClaim.vue?vue&type=script&lang=js"
export * from "./ListBuyerClaim.vue?vue&type=script&lang=js"
import style0 from "./ListBuyerClaim.vue?vue&type=style&index=0&id=27a0abc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0abc7",
  null
  
)

export default component.exports